export class ProdutoSegmento {
  public id: number;
  public id_produto: number;
  public segment: string;
  public created_at: Date;

  constructor() { }
}
